/**
 * Anti-corruption layer for the community site map API response.
 *
 * @module features/nativeInteractiveSiteMap/services/processCommunityMap
 */

/**
 * Maps a raw API site plan to the internal SiteMapResource shape.
 *
 * @param {object} siteMapApiResponse - Raw site plan entry from the API response (PascalCase)
 * @returns {SiteMapResource}
*/
function mapSitePlanToResource(siteMapApiResponse) {
  return {
    mapBlobUrl:           siteMapApiResponse.MapBlobUrl,
    bottomLeftLatitude:   siteMapApiResponse.BottomLeftLatitude,
    bottomLeftLongitude:  siteMapApiResponse.BottomLeftLongitude,
    topRightLatitude:     siteMapApiResponse.TopRightLatitude,
    topRightLongitude:    siteMapApiResponse.TopRightLongitude,
  };
}

/**
 * Maps the community site map API response to the primary site map resource.
 * Returns null when no site maps are present so the caller can filter safely.
 *
 * @param {object} siteMapApiResponse - Raw site map entry from the API response (PascalCase)
 * @returns {SiteMapResource|null}
 */
function processCommunityMap(siteMapApiResponse) {
  if (!siteMapApiResponse) {
    return null;
  }

  return mapSitePlanToResource();
}

export default processCommunityMap;